import { useState } from 'react';

import Sentry from 'libs/Sentry';

import useAuth from './useAuth';
import { useAppContext } from 'store/AppProvider';

/**
 * useSetUserData hooks to set user data
 */
const useSetUserData = () => {
    const { logIn } = useAppContext();
    const { getPermission, getAccessToken, getUserEmail } = useAuth();
    const [isLoading, setLoading] = useState(true);

    const setUserData = async () => {
        const token = await getAccessToken();

        if (!token) {
            localStorage.removeItem('token');

            return;
        }

        const group = await getPermission();
        const email = await getUserEmail();

        const userData = {
            group,
            token: token,
            email: email,
        };

        if (token) {
            localStorage.setItem('token', token);
        }

        Sentry.setUserData(userData);

        logIn(userData);
        setLoading(false);
    };

    return {
        setUserData: setUserData,
        isLoading: isLoading,
    };
};

export default useSetUserData;
